import React, {createContext, useContext} from 'react';
import PropTypes from 'prop-types';

const WidgetLabelChanged = createContext();

export const useWidgetLabelChanged = () => useContext(WidgetLabelChanged) || {};

export default function WidgetLabelChangedProvider({children, isLabelChanged = false}) {
  return (
    <WidgetLabelChanged.Provider value={{isLabelChanged}}>{children}</WidgetLabelChanged.Provider>
  );
}

WidgetLabelChangedProvider.propTypes = {
  children: PropTypes.node,
  isLabelChanged: PropTypes.bool
};
